// client/src/components/Admin/Dashboard/_shared/TopRoomsTable.js
//
// M06 Fase 6 + ext - Lista compacta de top de items (rutas K12, terapias REVI)
// Recibe el array `items` con { id, title, count }.
// Acepta `metricLabel` para personalizar la unidad ("usos", "sesiones").
// Acepta `emptyText` para personalizar el texto vacio.

import React from "react";
import styles from "./TopRoomsTable.module.scss";

export function TopRoomsTable({
  items,
  rooms,
  metricLabel = "usos",
  emptyText = "Aun no hay items con uso registrado",
  idKey = "id",
  titleKey = "title",
  countKey = "count",
}) {
  // Compat: en M06 inicial el prop era `rooms` con { roomId, title, useCount }.
  // Si se sigue usando `rooms`, lo normalizamos.
  const list =
    items ||
    (rooms || []).map((r) => ({
      id: r.roomId,
      title: r.title,
      count: r.useCount,
    }));

  if (!list || list.length === 0) {
    return (
      <div className={styles.topRoomsTable}>
        <div className={styles.empty}>{emptyText}</div>
      </div>
    );
  }

  return (
    <div className={styles.topRoomsTable}>
      {list.map((r, idx) => (
        <div key={r[idKey] || idx} className={styles.row}>
          <div className={styles.left}>
            <div className={styles.rank}>{idx + 1}</div>
            <div className={styles.title} title={r[titleKey]}>
              {r[titleKey] || "(sin nombre)"}
            </div>
          </div>
          <div className={styles.count}>
            {r[countKey] || 0} {metricLabel}
          </div>
        </div>
      ))}
    </div>
  );
}
